fx.ns("shared.social", class SocialAlbumsGallery extends fx.Component {
	constructor(props) {
		super(props.data);

		this._service = props.service;
		this._assets = props.assets;
		this._width = props.width;
		this._height = props.height;
	}

	// ------------- RENDER -------------- //

	create() {

		// Albums
		this.albumsContainer = new fx.components.Box('albums-container');
		this.addChild(this.albumsContainer, { width: '100%', height: "100%" });

		for (let i = 0; i < this.data.length; i++) {
			let item = this.data.getItemAt(i);

			this.albumsContainer.addChild(new shared.renderers.SocialAlbumRenderer(item, this._service), { width: this._width, height: this._height });
		}

		// Spinner
		this.albumsLoader = new fx.components.Image({ data: this._assets.loader, className: "spinner" })

		if (this.data.length == 0)
			this.albumsContainer.addChild(this.albumsLoader, { width: 40, height: 40, top: 'center', right: 'center' });
	}

	onReady() {
		super.onReady();

		this.on("scroll", this.doAlbumsLazyLoad, this.albumsContainer);
	}

	// ------------- HANDLERS -------------- //

	addNewAlbums() {
		let lastItemNumber = this.albumsContainer.getChilds().length;

		if (this.data.getItemAt(lastItemNumber)) {
			let item = this.data.getItemAt(lastItemNumber);
			this.albumsContainer.addChild(new shared.renderers.SocialAlbumRenderer(item, this._service), { width: this._width, height: this._height });
		}
	}

	doAlbumsLazyLoad() {
		if (!this._service.nextAlbums) return;

		if (this.data.albumsLazyLoadingActive === 1) return;

		let containerClientHeight = this.find(".albums-container").clientHeight;
		let containerScrollTop = this.find('.albums-container').scrollTop;
		let containerScrollHeight = this.find('.albums-container').scrollHeight;

		if (containerClientHeight + containerScrollTop > containerScrollHeight - 100) {
			this.data.albumsLazyLoadingActive = 1

			if (this.albumsLoader) {
				this.albumsContainer.removeChild(this.albumsLoader);
				this.albumsContainer.addChild(this.albumsLoader, { width: 40, height: 40, top: containerScrollHeight, right: 'center' });
			}

			this._service.getAlbums();
		}
	}

	// ------------- EVENTS -------------- //

	onDataUpdated(action) {
		if (action.type === 'addItem') {
			if (this.albumsLoader) this.albumsContainer.removeChild(this.albumsLoader);

			this.addNewAlbums();
		}
	}

});